import { AppNavLink } from '@/components/ui/AppLink';
import { useT } from '@/lib/i18n';
import { JUMP_LINKS } from './nav-items';
import { List } from '@/components/ui/List';

/**
 * The centred jump-link pill: `--glass` container, 100 px radius, items 14/24 `--fg-muted` → `--fg`,
 * padding 12×16. Hidden below `lg` (the mobile menu lists the same links). Unlike a one-page site
 * the pill's items are separate pages, so it is route navigation with `aria-current="page"` — there
 * is nothing on the home page to scroll-spy (D-110); in-page section navigation belongs to the
 * sections themselves.
 */
export function JumpLinks() {
  const t = useT();
  return (
    <nav className="jump-pill" aria-label={t('nav.primary')}>
      <List className="flex items-center">
        {JUMP_LINKS.map(({ to, labelKey }) => (
          <li key={to}>
            <AppNavLink to={to} className="jump-pill__link">
              {t(labelKey)}
            </AppNavLink>
          </li>
        ))}
      </List>
    </nav>
  );
}
